import { Component, OnInit,ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { DialogModule } from 'primeng/dialog';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { AttributesService } from '../../../core/services/attributes.service';
import { Color } from '../../../shared/models/Attribute';

@Component({
  selector: 'app-colors-admin',
  standalone: true,
  imports: [
    CommonModule, FormsModule, TableModule, ButtonModule,
    InputTextModule, DialogModule, ToastModule, ConfirmDialogModule
  ],
  providers: [MessageService, ConfirmationService],
  templateUrl: './colors-admin.html'
})
export class ColorsAdminComponent implements OnInit {

  colors: Color[] = [];
  color: Partial<Color> = {};
  colorDialog: boolean = false;
  submitted: boolean = false;

  constructor(
    private attrService: AttributesService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.loadColors();
  }

  loadColors() {
    this.attrService.getColors().subscribe(data => {this.colors = data; this.cdr.detectChanges()});
  }

  openNew() {
    this.color = { isActive: true, hexCode: '#000000' };
    this.submitted = false;
    this.colorDialog = true;
  }

  editColor(c: Color) {
    this.color = { ...c };
    this.colorDialog = true;
  }

  saveColor() {
    this.submitted = true;

    if (this.color.name?.trim() && this.color.hexCode?.trim()) {
      const request = this.color.id
        ? this.attrService.updateColor(this.color.id, this.color as Color)
        : this.attrService.createColor(this.color as Color);

      request.subscribe({
        next: () => {
          this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Color Guardado' });
          this.colorDialog = false;
          this.loadColors();
        },
        error: () => this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No se pudo guardar' })
      });
    }
  }

  toggleColor(c: Color) {
    this.confirmationService.confirm({
      message: `¿${c.isActive ? 'Desactivar' : 'Activar'} el color ${c.name}?`,
      header: 'Confirmar',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.attrService.toggleColor(c.id).subscribe(() => {
          this.messageService.add({severity:'success', summary:'Actualizado', detail:`Color ${c.isActive ? 'Desactivado' : 'Activado'}`});
          this.loadColors();
        });
      }
    });
  }
}